// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"styles_wrapper__fVyZ9","content":"styles_content__CIp_G","trigger":"styles_trigger__1OF7E"};